<template>
  <div class="home-container">
    <!-- 新增顶部导航栏 -->
    <HeaderCard />
    
    <!-- 内容区域 -->
    <div class="content">
      <!-- 放大标题 -->
      <h1 class="main-title">智能技术方案</h1>
      
      <!-- 三个功能区域 - 放大 -->
      <div class="features-container">
        <!-- 第一部分 -->
        <div class="feature-section">
          <div class="feature-text">智能填充合同文件</div>
          <div class="feature-subtext">上传合同文件和粘贴文字，生成完整合同</div>
          <div class="feature-image">
            <img :src="require('@/image/analytics.png')" alt="智能填充">
          </div>
          <button class="feature-btn" @click="startChat('fill')">立即使用</button>
        </div>
        
        <!-- 分割线 -->
        <div class="divider"></div>
        
        <!-- 第二部分 -->
        <div class="feature-section">
          <div class="feature-text">智能解析合同文件</div>
          <div class="feature-subtext">上传合同文件，智能解析合同</div>
          <div class="feature-image">
            <img :src="require('@/image/decision.png')" alt="智能解析">
          </div>
          <button class="feature-btn" @click="startChat">立即使用</button>
        </div>
        
        <!-- 分割线 -->
        <div class="divider"></div>
        
        <!-- 第三部分 -->
        <div class="feature-section">
          <div class="feature-text">智能模板填充方案</div>
          <div class="feature-subtext">选择模板，粘贴内容后智能填充</div>
          <div class="feature-image">
            <img :src="require('@/image/optimization.png')" alt="智能优化">
          </div>
          <button class="feature-btn" @click="startChat('optimize')">立即使用</button>
        </div>
      </div>
    </div>
	<!-- 第四部分 -->
	<CompanyInfo />
  </div>
</template>

<script>
// 引入 Header 组件
import HeaderCard from '@/components/HeaderCard.vue'

// 引入公司信息组件
import CompanyInfo from '@/components/CompanyInfo.vue'


export default {
  name: 'HomeView',
  components: {
    HeaderCard,
	CompanyInfo
  },
  methods: {
    startChat(type) {
      if (type === 'fill') {
        // 跳转到智能填充页面
        this.$router.push('/fill-contract')
      } else if (type === 'optimize') {
        this.$router.push('/optimize-contract')
      } else {
        // 其他功能跳转到聊天界面
        this.$router.push('/chat')
      }
    }
  }
}
</script>

<style scoped>
.home-container {
  position: relative;
  width: 100vw;
  min-height: 100vh;
  overflow-x: hidden;
  background-color: #f8f9fa;
  padding: 0;
}

.content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 1200px;
  margin: 0 auto;
  padding: 30px 40px;
  margin-top: 0;
}

/* 放大主标题 */
.main-title {
  font-family: "黑体", "SimHei", sans-serif;
  font-size: 36px;
  color: #333;
  margin-bottom: 40px;
  text-align: left;
  width: 100%;
  padding-left: 0;
  font-weight: 700;
}

/* 放大功能卡片容器 */
.features-container {
  display: flex;
  width: 100%;
  background: #FCFCFF;
  border-radius: 20px;
  box-shadow: 0 6px 30px rgba(0, 0, 0, 0.12);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 0, 0, 0.08);
  padding: 30px 0;
  min-height: 320px;
  margin-bottom: 30px;
}

.feature-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 25px;
}

/* 放大功能标题 */
.feature-text {
  font-size: 22px;
  font-weight: 700;
  color: #333;
  text-align: center;
  margin-bottom: 10px;
}

/* 放大副标题 */
.feature-subtext {
  font-size: 16px;
  color: #666;
  text-align: center;
  margin-bottom: 20px;
  line-height: 1.5;
}

/* 放大图片区域 */
.feature-image {
  width: 120px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 25px 0;
}

.feature-image img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

/* 放大按钮 */
.feature-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 14px 32px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
  margin-top: 20px;
}

.feature-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.6);
}

.feature-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 10px rgba(102, 126, 234, 0.4);
}

.divider {
  width: 1px;
  background-color: rgba(0, 0, 0, 0.1);
  margin: 30px 0;
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .content {
    padding: 25px 30px;
  }
  
  .main-title {
    font-size: 32px;
  }
  
  .features-container {
    min-height: 280px;
  }
  
  .feature-text {
    font-size: 20px;
  }
  
  .feature-subtext {
    font-size: 15px;
  }
  
  .feature-image {
    width: 100px;
    height: 100px;
  }
}

@media (max-width: 768px) {
  .content {
    padding: 20px;
  }
  
  .main-title {
    font-size: 28px;
    margin-bottom: 30px;
  }
  
  .features-container {
    flex-direction: column;
    min-height: auto;
    padding: 20px 0;
    border-radius: 16px;
  }
  
  .divider {
    width: 80%;
    height: 1px;
    margin: 20px auto;
  }
  
  .feature-section {
    padding: 20px;
  }
  
  .feature-text {
    font-size: 18px;
  }
  
  .feature-subtext {
    font-size: 14px;
  }
  
  .feature-image {
    width: 90px;
    height: 90px;
    margin: 20px 0;
  }
  
  .feature-btn {
    padding: 12px 28px;
    font-size: 15px;
  }
}

@media (max-width: 480px) {
  .content {
    padding: 15px;
  }
  
  .main-title {
    font-size: 24px;
  }
  
  .feature-text {
    font-size: 16px;
  }
  
  .feature-subtext {
    font-size: 13px;
  }
  
  .feature-btn {
    padding: 10px 24px;
    font-size: 14px;
  }
  
  .feature-image {
    width: 80px;
    height: 80px;
  }
}
</style>